import React from 'react';
import { createPortal } from 'react-dom';

// Drop-in replacement for next/head, aliased at bundle time.
//
// Only GetFontSelectorComponent uses <Head>, to add a Google Fonts <link>.
// Fonts (and @font-face) must be registered at the document level - a <link>
// inside a Shadow DOM does not reliably register fonts for the shadow tree -
// so we portal the children into document.head, which works for shadow content.
export default function NextHead({ children }) {
  if (typeof document === 'undefined' || !document.head) {
    return null;
  }

  return createPortal(children, document.head);
}
